import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { NotificationType } from '@app/shared/interfaces';
import { TitleService } from '@app/shared/services/title/title.service';
import { ToastNotificationsService } from '@app/shared/services/toast-notifications/toast-notifications.service';

@Component({
  standalone: false,
  selector: 'sbnb-password-set',
  templateUrl: './password-set.component.html',
  styleUrls: ['./password-set.component.scss'],
})
export class PasswordSetComponent implements OnInit {
  identifier: string;
  loading: boolean;
  newPassword: string;
  newPassword2: string;

  constructor(
    private titleService: TitleService,
    private authService: AuthenticationService,
    private route: ActivatedRoute,
    private router: Router,
    private toast: ToastNotificationsService
  ) {}

  ngOnInit() {
    this.titleService.manuallySet('Change password');

    this.identifier = this.route.snapshot.paramMap.get('identifier');

    if (!this.identifier) {
      this.router.navigate(['/user/hello']);
    }
  }

  setPasswordClicked() {
    if (this.newPassword !== this.newPassword2) {
      this.toast.open(`Hey! Your passwords don't seem to match!`, 'Dismiss', NotificationType.Error);

      return;
    }

    this.loading = true;

    this.authService.setNewPassword(this.identifier, this.newPassword).subscribe((res: any) => {
      if (res?.error) {
        this.toast.open(res.message, 'Dismiss', NotificationType.Error);

        this.loading = false;
        return;
      }

      this.loading = false;
    });
  }
}
